import React from 'react'
import { Link } from "react-router";
/* eslint-disable */
const Award = () => {
  return (
    <>
    
    <section className="award award-top">
            <div className="container">
              <div className="section-title text-center mb-60">
                <span
                  className="sub-title wow fadeInRight"
                  data-wow-duration=".7s"
                >
                  Our Award
                </span>
                <h3 className="title xb-split-text split-in-right">
                  Awards WE Get Over <br /> <span>The decade</span>
                </h3>
              </div>
              <div className="row">
                <div className="col-lg-6">
                  <div className="xb-award-box pos-rel ul_li">
                    <div className="xb-item--icon">
                      <img src="assets/img/icon/award_01.svg" alt="" />
                    </div>
                    <div className="xb-item--holder">
                      <h2 className="xb-item--title">
                        State-Level Bronze in
                        <br /> Web Development
                      </h2>
                    </div>
                    <Link to="/contact" className="xb-item--arrow">
                      <img src="assets/img/icon/arrow_right.svg" alt="" />
                    </Link>
                                       <Link className="xb-overlay" to="/contact"></Link>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="xb-award-box pos-rel ul_li">
                    <div className="xb-item--icon">
                      <img src="assets/img/icon/award_02.svg" alt="" />
                    </div>
                    <div className="xb-item--holder">
                      <h2 className="xb-item--title">
                        Gold in Web
                        <br /> Development Excellence
                      </h2>
                    </div>
                   <Link to="/contact" className="xb-item--arrow">
                      <img src="assets/img/icon/arrow_right.svg" alt="" />
                    </Link>
                                       <Link className="xb-overlay" to="/contact"></Link>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="xb-award-box pos-rel ul_li">
                    <div className="xb-item--icon">
                      <img src="assets/img/icon/award_03.svg" alt="" />
                    </div>
                    <div className="xb-item--holder">
                      <h2 className="xb-item--title">
                        Best Digital Marketing
                        <br /> Agency of Nangal
                      </h2>
                    </div>
                   <Link to="/contact" className="xb-item--arrow">
                      <img src="assets/img/icon/arrow_right.svg" alt="" />
                    </Link>
                                       <Link className="xb-overlay" to="/contact"></Link>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="xb-award-box pos-rel ul_li">
                    <div className="xb-item--icon">
                      <img src="assets/img/icon/award_04.svg" alt="" />
                    </div>
                    <div className="xb-item--holder">
                      <h2 className="xb-item--title">
                        Aiming to Be Top Digital
                        <br /> Marketing Agency of Himachal
                      </h2>
                    </div>
                   <Link to="/contact" className="xb-item--arrow">
                      <img src="assets/img/icon/arrow_right.svg" alt="" />
                    </Link>
                                       <Link className="xb-overlay" to="/contact"></Link>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="xb-award-box pos-rel ul_li">
                    <div className="xb-item--icon">
                      <img src="assets/img/icon/award_05.svg" alt="" />
                    </div>
                    <div className="xb-item--holder">
                      <h2 className="xb-item--title">
                        Aiming to Be Top Digital
                        <br /> Marketing Agency of Una
                      </h2>
                    </div>
                   <Link to="/contact" className="xb-item--arrow">
                      <img src="assets/img/icon/arrow_right.svg" alt="" />
                    </Link>
                    <Link className="xb-overlay" to="/contact"></Link>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="xb-award-box pos-rel ul_li">
                    <div className="xb-item--icon">
                      <img src="assets/img/icon/award_06.svg" alt="" />
                    </div>
                    <div className="xb-item--holder">
                      <h2 className="xb-item--title">
                        Striving to Lead Digital Marketing <br />& Web
                        Development in Punjab
                      </h2>
                    </div>
                   <Link to="/contact" className="xb-item--arrow">
                      <img src="assets/img/icon/arrow_right.svg" alt="" />
                    </Link>
                                       <Link className="xb-overlay" to="/contact"></Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
    </>
  )
}

export default Award
/* eslint-enable */